import { mapGetters } from 'vuex'
import { defaultCheckoutRoute, routeForVariant } from '../getCheckoutRoute'

/**
 * Tracks the store's assigned variant, falling back to defaultCheckoutRoute()
 * so SSR and hydration agree on an empty store. While assignment is in flight
 * it returns null, which makes BaseButton render a real `<button>` honouring
 * `disabled` rather than a navigable link.
 */
export const CheckoutRouteMixin = {
  computed: {
    ...mapGetters({
      abTestVariant: 'ab-test/getVariant',
      abTestResolved: 'ab-test/isResolved',
      abTestCartToken: 'cart/getCartToken'
    }),
    checkoutRoute (): { name: string } | null {
      if (this.isVariantPending) {
        return null
      }

      return this.abTestVariant ? routeForVariant(this.abTestVariant) : defaultCheckoutRoute()
    },
    isVariantPending (): boolean {
      return Boolean(this.abTestCartToken) && !this.abTestResolved
    }
  }
}
